import Dialog from '@mui/material/Dialog';
import Fade from '@mui/material/Fade';
import { TransitionProps } from '@mui/material/transitions';
import ZoButton from '@zonofi/zo-components/input/zo-button/zo-button';
import React from 'react';
import './confirmation-modal.scss';
import { PNGS } from '../../assets';

interface ConfirmationModalProps {
  open: boolean;
  onExitClick: () => void;
  onContinueClick: () => void;
}

const FadeTransition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Fade ref={ref} {...props} timeout={500} />;
});

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  open,
  onExitClick,
  onContinueClick,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onContinueClick}
      TransitionComponent={FadeTransition}
      PaperProps={{
        sx: {
          borderRadius: '32px',
        },
      }}
    >
      <div className="confirmation-modal">
        <img src={PNGS.ErrorRobotImage} alt="" width={150} height={170} />
        <div className="confirmation-modal-content">
          <span className="confirmation-modal-content-heading primary-font-bold">
            Just one click left to unlock AI for your business <br />- don’t
            quit now!
          </span>
        </div>
        <div className="confirmation-modal-buttons">
          <ZoButton
            label={'Quit Anyway'}
            onClick={onExitClick}
            className="exit-btn primary-font-semibold"
          />
          <ZoButton
            label={'Keep Training'}
            onClick={onContinueClick}
            className="continue-btn primary-font-semibold"
          />
        </div>
      </div>
    </Dialog>
  );
};
